export default __webpack_public_path__ + "static/media/weekend.01eebb53.png";